module.exports = __webpack_public_path__ + "img/ppc.40531ccf.svg";